module.exports = __webpack_public_path__ + "static/media/04_2.49d3977e.png";